import { Badge, Show, Space, Tag, Typography } from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { IPartnerUser } from "interfaces";
import { FC } from "react";

export const PartnerUsersShow: FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<IPartnerUser>();
  const data = queryResult.data?.data;

  return (
    <Show title="Detalhes do Usuário Parceiro" headerButtons={[]} isLoading={queryResult.isLoading}>
      <Typography.Title level={5}>Nome</Typography.Title>
      <Typography.Text>{data?.name ?? "-"}</Typography.Text>

      <Typography.Title level={5}>Username</Typography.Title>
      <Typography.Text>{data?.username ?? "-"}</Typography.Text>

      <Typography.Title level={5}>Parceiros</Typography.Title>
      <Space wrap>
        {data?.partners?.map((p) => <Tag key={p}>{p}</Tag>) ?? "-"}
      </Space>

      <Typography.Title level={5}>Status</Typography.Title>
      <Badge
        status={data?.status === "active" ? "success" : "default"}
        text={data?.status === "active" ? "Ativo" : "Inativo"}
      />

      <Typography.Title level={5}>Criado em</Typography.Title>
      <Typography.Text>
        {data?.created_at ? new Date(data.created_at).toLocaleString("pt-BR") : "-"}
      </Typography.Text>

      <Typography.Title level={5}>Atualizado em</Typography.Title>
      <Typography.Text>
        {data?.updated_at ? new Date(data.updated_at).toLocaleString("pt-BR") : "-"}
      </Typography.Text>
    </Show>
  );
};
